import { render } from "./NotificationDialog.vue?vue&type=template&id=1483a55c&ts=true"
import script from "./NotificationDialog.vue?vue&type=script&lang=ts"
export * from "./NotificationDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__